import { Box, Typography, TextField, styled } from "@mui/material";
import { assetIcons } from "../../../constants/assets";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import InlineSvg from "../inline-svg";

const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    color: "white",
    backgroundColor: "#131313",
    borderRadius: 12,
    "& fieldset": {
      borderColor: darkColors.borderGray,
    },
    "&:hover fieldset": {
      borderColor: darkColors.buttonTop,
    },
    "& .MuiInputBase-input::placeholder": {
      fontStyle: "italic",
      color: "rgba(255, 255, 255, 0.7)",
    },
  },
});

export default function AmountInput({ amount, setAmount }) {
  return (
    <Box>
      <Typography
        sx={{
          color: "white",
          mb: 2,
          mt: 1,
          fontSize: fontSizes.heading3,
          fontWeight: 700,
        }}
      >
        Amount
      </Typography>
      <Box sx={{ position: "relative" }}>
        <StyledTextField
          fullWidth
          value={amount}
          id="num"
          type="text"
          inputMode="numeric" // Shows numeric keyboard on mobile
          onChange={(e) => {
            const value = e.target.value;
            if (value === "" || /^[0-9]+$/.test(value)) {
              setAmount(value);
            }
          }}
          placeholder="Type Amount"
          InputProps={{
            endAdornment: (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "white",
                  p: 1,
                  px: 2,
                  borderRadius: "12px",
                  fontSize: fontSizes.heading3,
                  bgcolor: darkColors.currencyBg,
                }}
              >
                <InlineSvg
                  sx={{
                    verticalAlign: "middle",
                    mb: 0.4,
                  }}
                  url={assetIcons.currencyIcon}
                />
                USDC
              </Box>
            ),
          }}
        />
      </Box>
    </Box>
  );
}
